import React from "react";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Services from "../components/Services";
import styles from "./Landing.module.css";

const Landing: React.FC = () => {
  const servicesRef = React.useRef<HTMLElement>(null);
  const contactRef = React.useRef<HTMLElement>(null);

  return (
    <div className={styles.landing}>
      <Hero services={servicesRef} />
      <Services ref={servicesRef} contact={contactRef} />
      <Contact ref={contactRef} />
      <Footer />
    </div>
  );
};

Landing.displayName = "Landing";

export default Landing;
